import { SettingsServiceFunctionsDto } from '@sr/dto';
import { settingsApi } from '../api';

export const useServiceFunctionsSettings = () => {
  const { data, isLoading, error } = settingsApi.useGetServiceFunctionsSettingsQuery(undefined, { refetchOnMountOrArgChange: 120 });
  const [set] = settingsApi.useSetServiceFunctionsSettingsMutation();

  return {
    data: { createPayOrdersFromPurchases: data?.createPayOrdersFromPurchases ?? true, id: 1 },
    isLoading,
    error,
    update: (dto: SettingsServiceFunctionsDto) => set(dto).unwrap(),
  };
};
